import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import CreateWizardLayout from '../../../../../components/CreateWizardLayout';
import FormGroup from '../../../../../../../components/global/FormGroup';
import PhoneInput from '../../../../../../../components/global/PhoneInput';
import Label from '../../../../../../../components/global/Label';
import Alert from '../../../../../../../components/global/Alert';
import useOpenModal from '../../../../../../../hooks/useOpenModal';
import { LOGIN_AUTH_MODAL } from '../../../../../../../components/auth/LoginAuthModal';
import AuthLegalDisclosure from '../../../../../../../components/auth/AuthLegalDisclosure';

const propTypes = {
  values: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    phone_number: PropTypes.string,
    email_address: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
};
const FreemiumEventCreateRegistrationStep = ({
  values,
  errors,
  handleChange,
  handleBlur,
}) => {
  const openModal = useOpenModal();
  const errorList = Object.values(errors).filter(
    error => typeof error === 'string',
  );

  const onLogin = () => {
    openModal(LOGIN_AUTH_MODAL, {
      message: errors.force_login
        ? 'Looks like the email address provided already exists. Please login below'
        : undefined,
      defaultPhone: values.account_phone_number,
      defaultEmailAddress: values.account_email_address,
    });
  };

  useEffect(() => {
    if (errors.force_login) {
      onLogin();
    }
  }, [errors]);

  return (
    <CreateWizardLayout.Wrapper>
      <CreateWizardLayout.Content size="lg">
        <div className="row">
          <div className="col-12 col-md-6">
            <FormGroup
              id="account_first_name"
              name="account_first_name"
              label="First Name"
              labelType="expanded"
              placeholder="John"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.account_first_name}
            />
          </div>
          <div className="col-12 col-md-6">
            <FormGroup
              id="account_last_name"
              name="account_last_name"
              label="Last Name"
              labelType="expanded"
              placeholder="Smith"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.account_last_name}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <Label id="account_phone_number" labelType="expanded" required>
              Phone Number
            </Label>
            <PhoneInput
              id="account_phone_number"
              name="account_phone_number"
              labelSrOnly
              value={values.account_phone_number || '+1'}
              onChange={phone =>
                handleChange({
                  target: {
                    name: 'account_phone_number',
                    value: phone,
                  },
                })
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <FormGroup
              id="account_email_address"
              name="account_email_address"
              label="Email Address"
              labelType="expanded"
              placeholder="your@email.com"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.account_email_address}
            />
          </div>
        </div>
        {errorList.length > 0 && (
          <Alert type="danger" className="mt-1 text-normal">
            <ul className="mb-0">
              {errorList.map(error => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </Alert>
        )}
        <div>
          <AuthLegalDisclosure showSmsConsent smsCtaLabel="Continue" />
          <hr />
        </div>
      </CreateWizardLayout.Content>
    </CreateWizardLayout.Wrapper>
  );
};

FreemiumEventCreateRegistrationStep.propTypes = propTypes;

export default FreemiumEventCreateRegistrationStep;
